import axios from "axios";

const HandleSoundChange = async (data, token, setSoundPath, setMsg) => {
    const url = "https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile";

    const headerss = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
    }

    try {
        const res = await axios({
            method: 'Post',
            url: url,
            params: { mediaType: "sound" },
            data: data,
            headers: headerss
        });

        if (res.status === 200 && res.data.success) {
            setSoundPath("https://api.heryerdeingilizce.com/" + res.data.data.path);
            return true;
        }

        setMsg(res.data?.message || "Yükleme başarısız.");
        return false;

    } catch (err) {
        setMsg(err.message);
        return false;
    }
}

export default HandleSoundChange;